import moment from 'moment';

const DATE_FORMAT = 'YYYY/MM/DD';

const NAMED_DATES = {
    today: () => moment(),
    hoy: () => moment(),
    now: () => moment(),
    yesterday: () => moment().subtract(1, 'day'),
    ayer: () => moment().subtract(1, 'day'),
    startOfMonth: () => moment().startOf('month'),
    endOfMonth: () => moment().endOf('month'),
    startOfYear: () => moment().startOf('year'),
    endOfYear: () => moment().endOf('year'),
};

const OFFSET_EXPRESSION = /^(today|hoy|now|yesterday|ayer|startOfMonth|endOfMonth|startOfYear|endOfYear)\s*([+-])\s*(\d+)\s*([dmy])?$/i;

const namedKey = (token) => {
    const normalized = String(token || '').toLowerCase();
    return Object.keys(NAMED_DATES).find((key) => key.toLowerCase() === normalized) || null;
};

const unitFromToken = (token) => {
    const unit = String(token || 'd').toLowerCase();
    if (unit === 'm') return 'months';
    if (unit === 'y') return 'years';
    return 'days';
};

/**
 * Resuelve el defaultValue de un campo fecha a YYYY/MM/DD.
 * Acepta una fecha fija (YYYY/MM/DD, YYYY-MM-DD, DD/MM/YYYY)
 * o una expresión: today, hoy, yesterday, startOfMonth, endOfMonth,
 * startOfYear, endOfYear, y offsets como today-7, today+1d, startOfMonth-1m.
 * @param {*} defaultValue
 * @returns {string|null}
 */
export function resolveDateDefault(defaultValue) {
    if (defaultValue == null || defaultValue === '') return null;

    if (moment.isMoment(defaultValue) && defaultValue.isValid()) {
        return defaultValue.clone().format(DATE_FORMAT);
    }

    if (defaultValue instanceof Date && !Number.isNaN(defaultValue.getTime())) {
        return moment(defaultValue).format(DATE_FORMAT);
    }

    const raw = String(defaultValue).trim();
    if (!raw) return null;

    const literal = moment(raw, ['YYYY/MM/DD', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
    if (literal.isValid()) return literal.format(DATE_FORMAT);

    const named = namedKey(raw);
    if (named) return NAMED_DATES[named]().format(DATE_FORMAT);

    const offset = raw.match(OFFSET_EXPRESSION);
    if (!offset) return null;

    const baseName = namedKey(offset[1]);
    if (!baseName) return null;

    const amount = Number(offset[3]) * (offset[2] === '-' ? -1 : 1);
    return NAMED_DATES[baseName]().add(amount, unitFromToken(offset[4])).format(DATE_FORMAT);
}

export function isEmptyDateValue(value) {
    return value === undefined || value === null || String(value).trim() === '';
}
